// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion-module__Accordion--m4mt6"};